// extracted by mini-css-extract-plugin
export default {"container":"empty-orders_container__RcinK","title":"empty-orders_title__neswn","img":"empty-orders_img__TjqXH","btn":"empty-orders_btn__L41nJ"};